<template>
  <div class="about">
    <div class="top">
      <span>关于我们</span>
      <span>About us</span>
    </div>
    <div class="about_tab" id="jianjie">
      <div class="tab_jianjie">
        <span>公司简介</span>
      </div>
    </div>
    <div class="zhihui">
      <img src="//static.h5.ylmob.com/website/img/gy-logo.png" />
      <div class="zhihui_d">
        <span>本体教育</span>
        <span>一家以人工智能、大数据分析、教育信息化、网络化营销业务为核心的新一代信息技术产业公司，公司立足于教育行业版块，业务涵盖教育局大数据开发、教育SaaS应用软件开发、教育硬件Aiot集成、教育在线内容和商城、区域化教育周边等；我们 拥有顶尖的营销、产品设计和技术团队，核心成员毕业于剑桥大学、浙江大学等世界一流名校；为区县级教育局提供 “教育+AIoT” 数字教育生态解决方案，已服务于1000多所学校、100多万师生以及800多家教育机构，联合教育各行业打造了区域数字经济体的生态圈，我们致力于以卓越科技能力助力教育领域的数字化转型。</span>
      <!--  <span>目前，本体教育拥有人证通系统、人脸访客系统、人脸签到系统、人脸门禁系统、人脸闸机系统、人像预警系统六大通用性人脸识别产品；旗下产品本体教育科技，专注于K12校园的Saas软件与智能硬件服务，为教育管理者、学校、老师、学生、家长，提供教学管理、教务管理、家校互动、平安校园、校园协作等一体化信息服务解决方案，让校园协作更简单。</span> -->
      </div>
    </div>
    <div class="dingwei">
      <span>国内领先的智慧校园平台服务商</span>
      <div class="dingwei_bg">
        <span>企业定位</span>
      </div>
    </div>
    <div class="chuangye">
      <div class="chuangye_bg">
        <span>企业创业观</span>
      </div>
      <span>开放、分享、速度、服务、责任</span>
    </div>
    <h3>企业价值观</h3>
    <div class="short_stub">
      <div></div>
      <div></div>
    </div>
    <div class="jiazhi">
      <div class="jiazhi_i">
        <div class="jiazhi_i_l">
          客户
          <br />导向
        </div>
        <span>
          满足客户需求
          <br />为客户创造价值
        </span>
      </div>
      <div class="jiazhi_i">
        <div class="jiazhi_i_m">
          服务
          <br />至上
        </div>
        <span>服务好客户<br />伙伴、团队和股东</span>
      </div>
      <div class="jiazhi_i">
        <div class="jiazhi_i_r">
          团队
          <br />共赢
        </div>
        <span>
          团队共同成长
          <br />价值共分享
        </span>
      </div>
    </div>

    <div class="about_bottom" id="lianxi">
      <img src="/img/img.map.png" />
      <div class="about_bottom_r">
        <div class="triangle"></div>
        <div class="about_us">
          <span class="about_cn">联系我们</span>
          <span class="about_en">contact us</span>
          <div class="about_bottom_c">
            <div class="su_line"></div>
            <div class="about_bottom_t">
              <span>公司地址：浙江省杭州市拱墅区网云街566号威新曦地科创中心14幢12层1202室</span>
              <span>客服电话：-</span>
              <span>公司邮箱：-</span>
              <span>邮政编码：-</span>
              <span>商务合作 QQ：-</span>
              <span>技术咨询 QQ：-</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {
    $route() {
      // console.log("about created:  "+ to + from);
      // this.$router.go(0)
      console.log("about created:  " + this.$route.query.tab);
      if (this.$route.query.tab == 1) {
        document.getElementById("lianxi").scrollIntoView();
      } else if(this.$route.query.tab == 0) {
        document.getElementById("jianjie").scrollIntoView();
      }
    }
  },
  methods: {},
  created() {
    // console.log("about created:  "+ this.$route.query.tab);
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
};
</script>
<style scoped>
.about {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.top {
  width: 100%;
  height: 2.604167rem;
  background: url("//static.h5.ylmob.com/website/img/img_top_about.png")
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.top span:nth-child(1) {
  font-size: .3125rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: .3125rem;
}
.top span:nth-child(2) {
  font-size: .15625rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  line-height: .15625rem;
  margin-top: 0.15625rem;
}
.about_tab {
  width: 6.25rem;
  height: 0.3125rem;
  display: flex;
  align-items: center;
  margin-top: 0.104167rem;
}
.tab_jianjie {
  width: 1.5625rem;
  height: 0.3125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 0.010417rem solid rgba(47, 110, 240, 1);
}
.tab_jianjie span {
  font-size: 0.09375rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(47, 110, 240, 1);
  line-height: 0.09375rem;
}
.zhihui {
  display: flex;
  align-items: center;
  margin-top: 0.416667rem;
}
.zhihui img {
  width: 2.604167rem;
  height: 1.458333rem;
  margin-right: 0.223958rem;
}
.zhihui_d {
  width: 3.4375rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.zhihui_d span:nth-child(1) {
  font-size: 0.125rem;
  font-weight: 600;
  color: rgba(63, 110, 240, 1);
  line-height: 0.125rem;
  margin-bottom: 0.083333rem;
}
.zhihui_d span:nth-child(2) {
  font-size: 0.083333rem;
  font-weight: 400;
  color: #091630;
  line-height: 0.125rem;
  margin-bottom: 0.083333rem;
  text-align: left;
}
.zhihui_d span:nth-child(3) {
  font-size: 0.083333rem;
  font-weight: 400;
  color: #091630;
  line-height: 0.125rem;
  text-align: left;
}
.dingwei {
  display: flex;
  align-items: center;
  margin-top: 0.625rem;
}
.dingwei > span {
  width: 3.125rem;
  font-size: 0.125rem;
  font-weight: 600;
  color: rgba(63, 110, 240, 1);
  line-height: 0.125rem;
  text-align: center;
}
.dingwei_bg {
  width: 3.125rem;
  height: 0.833333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(//static.h5.ylmob.com/website/img/qydingwei.png) no-repeat;
  background-size: 100% 100%;
}
.dingwei_bg span {
  font-size: 0.15625rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.15625rem;
}
.chuangye {
  display: flex;
  align-items: center;
  margin-bottom: 0.3125rem;
}
.chuangye > span {
  width: 3.125rem;
  font-size: 0.125rem;
  font-weight: 600;
  color: rgba(63, 110, 240, 1);
  line-height: 0.125rem;
  text-align: center;
}
.chuangye_bg {
  width: 3.125rem;
  height: 0.833333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(//static.h5.ylmob.com/website/img/chuanyeguan.png) no-repeat;
  background-size: 100% 100%;
}
.chuangye_bg span {
  font-size: 0.15625rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.15625rem;
}
.jiazhi {
  display: flex;
  align-items: flex-start;
}
.jiazhi_i {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0.677083rem;
}
.jiazhi_i > span {
  font-size: 0.083333rem;
  font-weight: 400;
  color: rgba(9, 22, 48, 1);
  line-height: 0.125rem;
}
.jiazhi_i_l {
  width: 0.729167rem;
  height: 0.729167rem;
  background: rgba(252, 129, 17, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.15625rem;
  font-size: 0.125rem;
  font-weight: 600;
  color: rgba(252, 129, 17, 1);
  line-height: 0.166667rem;
}
.jiazhi_i_m {
  width: 0.729167rem;
  height: 0.729167rem;
  background: rgba(47, 110, 240, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.15625rem;
  font-size: 0.125rem;
  font-weight: 600;
  color: rgba(47, 110, 240, 1);
  line-height: 0.166667rem;
}
.jiazhi_i_r {
  width: 0.729167rem;
  height: 0.729167rem;
  background: rgba(78, 207, 210, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.15625rem;
  font-size: 0.125rem;
  font-weight: 600;
  color: rgba(78, 207, 210, 1);
  line-height: 0.166667rem;
}
.about_bottom {
  display: flex;
  align-items: center;
  margin-top: 0.625rem;
  margin-bottom: .520833rem;
}
.about_bottom img {
  width: 3.645833rem;
  height: 2.083333rem;
  margin-right: 0.260417rem;
}
.about_bottom_r {
  height: 1.666667rem;
  box-shadow: 0px 0.208333rem 0.416667rem -0.208333rem rgba(63, 110, 240, 0.2);
  display: flex;
  align-items: center;
}
.triangle {
  width: 0;
  height: 0;
  border-top: 0.104167rem solid transparent;
  border-right: 0.208333rem solid rgba(255, 255, 255, 1);
  border-bottom: 0.104167rem solid transparent;
  border-left: 0.104167rem solid transparent;
}
.about_us {
  flex: 1;
  height: 1.666667rem;
  background: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.about_cn {
  font-size: 0.125rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  margin-top: 0.15625rem;
}
.about_en {
  font-size: 0.072917rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(63, 110, 240, 1);
  line-height: 0.104167rem;
}
.about_bottom_c {
  display: flex;
  align-items: center;
  margin-top: 0.15625rem;
}
.su_line {
  width: 0.020833rem;
  height: 0.916667rem;
  background: rgba(63, 110, 240, 1);
}
.about_bottom_t {
  display: flex;
  height: 0.916667rem;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin-left: 0.104167rem;
}
.about_bottom_t span {
  font-size: 0.083333rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(76, 76, 76, 1);
  line-height: 0.083333rem;
}
</style>